// This enum should be the same on the FE and BE.
export const mailToTypes = Object.freeze({
  DRIVER_SHIFT_REQUEST: 'DRIVER_SHIFT_REQUEST',
  DRIVER_SHIFT_UPDATE_REQUEST: 'DRIVER_SHIFT_UPDATE_REQUEST',
  BUS_STOP_REQUEST: 'BUS_STOP_REQUEST',
  BUS_STOP_EDIT_REQUEST: 'BUS_STOP_EDIT_REQUEST',
  BUS_STOP_DELETE_REQUEST: 'BUS_STOP_DELETE_REQUEST',
  DRIVER_SHIFT_LAST_MINUTE_CHANGE: 'DRIVER_SHIFT_LAST_MINUTE_CHANGE'
});
